module.exports = __webpack_public_path__ + "static/media/periodic-table-weiss.26058256.png";